import type { LocationQuery, LocationQueryValue } from 'vue-router'
import { isNullUndefinedOrEmptyString } from './object'

/** Fabrique un objet LocationQuery du router à partir
 * d'un objet en eliminant null, undefined, chaines vides et tableaux vides
 */
export function buildLocationQuery(query: object) {
  return Object.entries(query)
    .filter(([_key, value]) => {
      if (Array.isArray(value)) {
        return value.length > 0
      }
      return !isNullUndefinedOrEmptyString(value)
    })
    .reduce((acc, [key, value]) => {
      acc[key] = value
      return acc
    }, {} as LocationQuery)
}

/**
 * Extrait un LocationQueryValue en string[]
 * @param param Le location query à extraire
 * @param defaultValue Une valeur par défaut. Ex : param undefined
 * @returns
 */
export function locationQueryValueToArray(
  param: LocationQueryValue | LocationQueryValue[] | undefined,
  defaultValue?: string[],
): string[] | undefined {
  if (param === undefined || param === '') return defaultValue
  if (Array.isArray(param)) return param as string[]
  return [param as string]
}

